<cc-box class="number-details-wrapper" *ngIf="data">
  <div class="number-details-header" box header>
    <p class="number-details-title">{{'RECORDS_LIST.GENERAL_DETAILS' |  translate}}</p>
  </div>

  <div class="box-content number-details-content" box content>
    <div class="number-details-content-row">
      <div class="number-details-content-row-label">{{'RECORDS_LIST.RECORDS_ID' | translate}}</div>
      <div *ngIf="data && data.id"
           class="number-details-content-row-value">{{data.id}}</div>
    </div>
    <div class="number-details-content-row">
      <div class="number-details-content-row-label">{{'EVENT_DETAILS.IMPORT_DATE' | translate}}</div>
      <div *ngIf="data && data.importDate"
           class="number-details-content-row-value">{{formatDate(data.importDate)}}</div>
    </div>
    <div class="number-details-content-row">
      <div class="number-details-content-row-label">{{'RECORDS_LIST.PHONE_NUMBERS' | translate}}</div>
    </div>

    <div class="number-details-form form-group">
      <div class="number-details-input-wrapper">
        <input type="text" class="form-control"
               [formControl]="newPrimaryNumber"
               [placeholder]="'RECORDS_LIST.ADD' | translate">
        <small class="error-alert" *ngIf="newPrimaryNumber.touched && newPrimaryNumber.hasError('required')">
          {{'REQUIRED_FIELD_MESSAGE' | translate}}</small>
        <small class="error-alert" *ngIf="newPrimaryNumber.hasError('INVALID_MSISDN')">
          {{'RECORDS_LIST.MSISDN_INVALID' | translate}}
        </small>
        <small class="error-alert" *ngIf="newPrimaryNumber.hasError('MSISDN_EXISTS_IN_PROJECT')">
          {{'RECORDS_LIST.MSISDN_EXISTS_IN_PROJECT' | translate}}</small>
      </div>
      <div class="number-details-button-wrapper">
        <button class="btn primary-full" type="submit"
                [disabled]="isNumberValid()"
                (click)="save()"
                translate="ADD"></button>
      </div>
    </div>

    <div class="number-details-list">
      <div class="number-details-items" *ngIf="numbersConfig">
        <div class="number-details-item-wrapper"
             *ngFor="let number of numbersConfig.alternativeMsisdns">
          <span class="number-details-item">
              <span class="number-details-item-number">
                <span *ngIf="number.msisdn"
                      class="flag-icon flag-icon-{{getIsoCountry(number.msisdn)}} m-r-sm shadow-up"></span>
                <span>{{number.msisdn | phoneNumber}}</span>
                <cc-call-icon
                  *ngIf="getIsoCountry(number.msisdn)"
                  [number]="number.msisdn"
                ></cc-call-icon>
              </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</cc-box>
